import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import UserFieldProps from "../../services/models/formModels/userFieldsProps.model";

function OfficeManagerFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  isSignUpFlow,
  values,
}: UserFieldProps): JSX.Element {
  return (
    <FieldRenderer
      fields={dataConstants.officeManagerFields
        .filter((field) => {
          if (isSignUpFlow) {
            return (
              ["profileImage", "phone", "fax"].includes(
                field?.name ? field.name : ""
              ) === false
            );
          }
          return true;
        })
        .map((field, index) => ({
          key: `${index}${field.id}`,
          ...field,
          errors: errors,
          touched: touched,
          roundedInput:true,
          onChange: handleChange,
          value: isSignUpFlow
            ? values?.user?.[!!field.name ? field.name : ""]
            : values?.[!!field?.name ? field.name : ""],
          onBlur: handleBlur,
          name: isSignUpFlow ? `user.${field.name}` : field.name,
        }))}
    />
  );
}

export default OfficeManagerFields;
